<section class="storage-usage" aria-labelledby="storage-usage-title">
  <div class="storage-usage__header">
    <h2 id="storage-usage-title" class="storage-usage__title">Almacenamiento de imágenes</h2>
    @if (storageUsage()) {
      <span class="storage-usage__summary">{{ usedLabel() }} de {{ limitLabel() }}</span>
    }
  </div>

  @if (isLoading()) {
    <p class="storage-usage__message" role="status">Calculando almacenamiento...</p>
  } @else if (hasLoadError()) {
    <p class="storage-usage__message" role="alert">
      No pudimos calcular el almacenamiento usado.
      <button type="button" class="storage-usage__retry" (click)="loadStorageUsage()">Reintentar</button>
    </p>
  } @else if (storageUsage(); as usage) {
    <div
      class="storage-usage__track"
      role="progressbar"
      aria-labelledby="storage-usage-title"
      [attr.aria-valuenow]="usedPercentage().toFixed(1)"
      aria-valuemin="0"
      aria-valuemax="100"
      [attr.aria-valuetext]="usedLabel() + ' de ' + limitLabel()"
    >
      <div
        class="storage-usage__fill"
        [class.storage-usage__fill--warning]="usageLevel() === 'warning'"
        [class.storage-usage__fill--critical]="usageLevel() === 'critical'"
        [style.width.%]="usedPercentage()"
      ></div>
    </div>
    <p class="storage-usage__detail">
      {{ usedPercentage().toFixed(1) }}% usado · {{ usage.objectCount }} archivos.
      Cada imagen se optimiza a WebP de máximo 200 KB al subirla.
    </p>
  }
</section>
